import Http from '@/api/http.js'
export default {
  indexReversal(filter){
    return Http.get(`clients/${client_id}/reversals`, {
      headers: {
        filter: JSON.stringify(filter? filter : null)
      }
    });
  },
  createReversal(new_reversal){
    const {ammount, comment, due_date, payment_description, place_id} = new_reversal
    return Http.post(`clients/${new_reversal.client_id}/reversals`, {
      reversal:{
        ammount,
        comment,
        payment_description,
        place_id,
        due_date
      }
    })

  },
}